import { loadCSS } from '../../utils';
let view = null;

export default {
	namespace: 'template-about',
	beforeEnter: async ({ current, next, trigger }) => {
		await loadCSS(WPDATA.themeUrl + '/dist/css/t-about.css');

		const { default: TemplateAbout } = await import(
			/* webpackChunkName: "template-about" */ '../../templates/TemplateAbout'
		);
		view = new TemplateAbout(next.container);
		view.init();
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
